import { CapabilityViewType } from '../../enums/CapabilityViewType';
import { EmployeePositionId } from './Employee';

/**
 * A class represents a requirement for a specific capability, and who is available to fulfill it.
 */
export class CapabilityView {
  requiredCapability: CapabilityViewType;
  date: string;
  startTime: string;
  endTime: string;
  availableEmployees: EmployeePositionId[];
  requiredEmployees: number;

  /**
   * @param type the type of capability that needs to be fulfilled.
   * @param date the specific date, to which the requirement applies.
   * @param startTime the beginning of the period when the capability is required.
   * @param endTime the end of the period when the capability is required.
   * @param availableEmployees the list of all employee/position ids that are available to fulfill this capability.
   * @param requiredEmployees the number of employees that is required.
   */
  constructor(
    type: CapabilityViewType,
    date: string,
    startTime: string,
    endTime: string,
    availableEmployees: EmployeePositionId[],
    requiredEmployees: number
  ) {
    this.requiredCapability = type;
    this.date = date;
    this.startTime = startTime;
    this.endTime = endTime;
    this.availableEmployees = availableEmployees;
    this.requiredEmployees = requiredEmployees;
  }
}
